/**
 * ToolbarTitle  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

export interface ToolbarTitleProps {}

export const ToolbarTitle: React.FC<ToolbarTitleProps> = ({ children }) => (
	<div className="edt-toolbar-title">{children}</div>
);
